import {
  Film,
  Pencil,
  Scissors,
  ShoppingBag,
  UserRound,
  type LucideIcon,
} from 'lucide-react';

import { cn } from '@/lib/cn';
import type { ConversationTaskFamilyKey } from './contract';

const CONVERSATION_TASK_FAMILY_ICONS = {
  product: ShoppingBag,
  person: UserRound,
  design: Pencil,
  kagemane: Film,
  reference: Scissors,
} as const satisfies Record<ConversationTaskFamilyKey, LucideIcon>;

interface TaskFamilyIconProps {
  family: ConversationTaskFamilyKey;
  className?: string;
}

/** Shared semantic icon used by every Explore task-family entry point. */
export function TaskFamilyIcon({ family, className }: TaskFamilyIconProps) {
  const Icon = CONVERSATION_TASK_FAMILY_ICONS[family];
  return <Icon className={cn('h-4 w-4', className)} strokeWidth={1.8} aria-hidden />;
}

interface TaskFamilyIconTileProps extends TaskFamilyIconProps {
  tileClassName?: string;
}

/** Shared size, line weight, and container treatment for Explore family icons. */
export function TaskFamilyIconTile({ family, className, tileClassName }: TaskFamilyIconTileProps) {
  return (
    <span
      className={cn(
        'flex h-10 w-10 shrink-0 items-center justify-center rounded-[9px] bg-white text-[#536779] shadow-[0_2px_8px_rgba(15,23,42,0.04)] transition-colors',
        tileClassName,
      )}
    >
      <TaskFamilyIcon family={family} className={className} />
    </span>
  );
}
